<template>
  <div class="body-main-container">
    <div class="login-main-container">
      <div class="imagelogin-container">
        <img
          src="../assets/loginimage.webp"
          alt="Imagen de Login"
          class="reset-login-image"
        />
      </div>
      <div class="contentmain-container">
        <div class="d-flex align-items-center mb-4">
          <img src="../assets/logobaessh.svg" alt="Logo Baessh" style="width: 3rem; margin-right: 0.5rem;">
          <span class="brand-text font-weight-light" style="font-size: 1.5rem;">BAESSH</span>
        </div>

        <div class="reset-message-container mb-4">
          <div class="alert alert-success reset-alert" role="alert" v-if="successMessage">
            {{ successMessage }}
          </div>
          <div class="alert alert-danger reset-alert" role="alert" v-else-if="errorMessage">
            {{ errorMessage }}
          </div>
          <span v-else><b>Restablecer contraseña</b></span>
        </div>

        <div v-if="!token" class="text-center">
          <router-link to="/recuperacion" class="btn btn-secondary">
            Solicitar recuperación
          </router-link>
          <div class="mt-3">
            <router-link to="/" class="btn btn-link reset-back-link">
              <i class="fa fa-solid fa-arrow-left"></i> Volver a iniciar sesión
            </router-link>
          </div>
        </div>

        <form v-else-if="!successMessage" @submit.prevent="restablecerPassword" class="reset-form" novalidate>
          <div class="input-group mb-3">
            <input
              id="new-password"
              type="password"
              class="form-control"
              v-model="password"
              name="password"
              autocomplete="new-password"
              placeholder="Nueva contraseña"
              :disabled="loading"
            >
            <div class="input-group-append">
              <div class="input-group-text">
                <span class="fa fa-lock" style="font-size: 20px;"></span>
              </div>
            </div>
          </div>
          <div
            class="password-rule mb-3"
            :class="{ 'password-rule-success': passwordMeetsMinLength }"
            aria-live="polite"
          >
            <i
              class="fa"
              :class="passwordMeetsMinLength ? 'fa-check-circle' : 'fa-info-circle'"
              aria-hidden="true"
            ></i>
            <span>Mínimo 8 caracteres</span>
          </div>

          <div class="input-group mb-4">
            <input
              id="confirm-password"
              type="password"
              class="form-control"
              v-model="confirmPassword"
              name="confirmPassword"
              autocomplete="new-password"
              placeholder="Confirmar nueva contraseña"
              :disabled="loading"
            >
            <div class="input-group-append">
              <div class="input-group-text">
                <span class="fa fa-lock" style="font-size: 20px;"></span>
              </div>
            </div>
          </div>

          <button type="submit" class="btn btn-secondary" :disabled="loading">
            <span
              v-if="loading"
              class="spinner-border spinner-border-sm mr-2"
              role="status"
              aria-hidden="true"
            ></span>
            {{ loading ? 'Restableciendo...' : 'Restablecer contraseña' }}
          </button>

          <div v-if="showRecoveryLink" class="mt-3">
            <router-link to="/recuperacion" class="btn btn-link reset-back-link">
              Solicitar un nuevo enlace
            </router-link>
          </div>
          <div class="mt-3">
            <router-link to="/" class="btn btn-link reset-back-link">
              <i class="fa fa-solid fa-arrow-left"></i> Volver a iniciar sesión
            </router-link>
          </div>
        </form>

        <div v-else class="text-center">
          <router-link to="/" class="btn btn-secondary">
            Ir al login
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axiosInstance from '../services/axiosInstance';

export default {
  name: 'RestablecerPassword',
  data() {
    return {
      password: '',
      confirmPassword: '',
      errorMessage: '',
      successMessage: '',
      loading: false,
      redirectTimer: null,
      showRecoveryLink: false
    };
  },
  computed: {
    token() {
      return this.$route.query.token || '';
    },
    passwordMeetsMinLength() {
      return this.password.length >= 8;
    }
  },
  created() {
    if (!this.token) {
      this.errorMessage = 'El enlace de recuperación no es válido.';
    }
  },
  beforeDestroy() {
    if (this.redirectTimer) {
      window.clearTimeout(this.redirectTimer);
    }
  },
  methods: {
    validarFormulario() {
      if (!this.password) {
        return 'La nueva contraseña es obligatoria.';
      }

      if (!this.confirmPassword) {
        return 'La confirmación de contraseña es obligatoria.';
      }

      if (this.password.length < 8) {
        return 'La contraseña debe tener al menos 8 caracteres';
      }

      if (this.password !== this.confirmPassword) {
        return 'Las contraseñas no coinciden.';
      }

      return '';
    },
    async restablecerPassword() {
      if (this.loading || !this.token) return;

      this.errorMessage = this.validarFormulario();
      this.showRecoveryLink = false;

      if (this.errorMessage) return;

      this.loading = true;

      try {
        await axiosInstance.post('/users/reset-password', {
          token: this.token,
          password: this.password
        });

        this.password = '';
        this.confirmPassword = '';
        this.successMessage = 'Tu contraseña fue actualizada correctamente.';
        this.redirectTimer = window.setTimeout(() => {
          this.$router.push('/');
        }, 3000);
      } catch (error) {
        const message = error.response?.data?.message || 'Ocurrio un error inesperado';
        this.errorMessage = message;
        this.showRecoveryLink = message.toLowerCase().includes('inválido') ||
          message.toLowerCase().includes('invalido') ||
          message.toLowerCase().includes('expiró') ||
          message.toLowerCase().includes('expiro');
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.reset-login-image {
  width: 100%;
  height: 100%;
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
  filter: brightness(90%) contrast(105%);
  object-fit: cover;
}

.reset-form,
.reset-message-container {
  width: min(100%, 22rem);
}

.reset-message-container {
  min-height: 2.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.reset-alert {
  width: 100%;
  margin: 0;
  padding: 0.65rem 0.85rem;
  font-size: 0.9rem;
  line-height: 1.3;
  overflow-wrap: anywhere;
}

.reset-back-link {
  text-decoration: none;
  font-weight: 700;
  font-size: 13px;
}

.password-rule {
  width: min(100%, 22rem);
  display: flex;
  align-items: center;
  gap: 0.35rem;
  color: #6c757d;
  font-size: 0.78rem;
  line-height: 1.2;
}

.password-rule-success {
  color: #198754;
  font-weight: 600;
}
</style>
